import "@babel/polyfill";
import 'es6-shim';
import React from 'react';
import dva from 'dva';
import createHistory from 'history/createBrowserHistory';
// import createLoading from 'dva-loading';
import { Router, Route } from 'dva/router';
import models from './model';
import App from './layout/app';
import env from './lib/env';
import './index.css';
import 'rc-banner-anim/dist/rc-banner-anim.min.css';


/*
 * 这是解决antd-mobile listview的bodyscroll模式在ie11下的不能触底加载问题
 */
if (!document.scrollingElement) {
    document.scrollingElement = {};
    window.addEventListener('scroll', (e) => {
        document.scrollingElement.scrollTop = document.documentElement.scrollTop; 
    });
}

const app = dva({
    history: createHistory() 
});
env.init(app)
try {
    models.forEach(m => {
        app.model(m);
    });
    app.router(({history}) =>
        <Router history={history}>
            <Route path="/" component={App} />
        </Router>
    );
    app.start('#root');
    //env.dispatch({ type: 'ad/load' });
    //env.dispatch({ type: 'user/brief' });
    env.dispatch({ type: 'search/init' });
} catch(e) {
    console.log(e);
};




// WEBPACK FOOTER //
// ./src/index.js